import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Grid,
  IconButton,
  Collapse,
  Box,
  Alert,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import getGpuTypeName from '@/components/jobs/getGpuTypeName';
import GpuClassDetail from './GpuClassDetail';

const cpu_gpu_type_id = '78201a90-ca48-4147-b6f5-fec51b4bd7db';

export default function ResourcesReview({ data }) {
  const [expanded, setExpanded] = useState(true);
  const gpu_classes = useSelector((state) => state.gpuClasses || []);

  if (!data) {
    return null;
  }

  const {
    job_name,
    gpu_types,
    gpu_count,
    cpu_count,
    disk_size,
    max_price,
    preemptible,
    available,
    worker_count,
    datasets_size,
  } = data;

  const cpu_only = gpu_types?.[0] === cpu_gpu_type_id;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          p: 1,
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <IconButton size='small'>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Typography variant='h6'>Resources</Typography>
      </Box>
      <Collapse in={expanded}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Typography>
                Job Name: <b>{job_name}</b>
              </Typography>
            </Grid>

            {gpu_types && gpu_types.length ? (
              <>
                <Grid size={12}>
                  <Typography variant='h6' sx={{ mt: 1, mb: 1 }}>
                    GPU Types
                  </Typography>
                  {gpu_types.map((gpu_type_id, idx) => {
                    const gpu_class = gpu_classes.find(
                      (gc) => gc.id === gpu_type_id,
                    );
                    const gpu_name = getGpuTypeName(gpu_type_id, gpu_classes);
                    return (
                      <Box key={idx} sx={{ mb: 2 }}>
                        {gpu_class && gpu_class.details ? (
                          <GpuClassDetail details={gpu_class.details} />
                        ) : (
                          <Typography>
                            GPU Type: <b>{gpu_name || gpu_type_id}</b>
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Grid>
              </>
            ) : null}

            {cpu_only ? (
              <Grid size={12}>
                <Typography>
                  CPU Count: <b>{cpu_count}</b>
                </Typography>
              </Grid>
            ) : (
              <Grid size={12}>
                <Typography>
                  GPU Count: <b>{gpu_count}</b>
                </Typography>
                <Typography>
                  CPU Count: <b>{cpu_count}</b>
                </Typography>
              </Grid>
            )}

            <Grid size={12}>
              <Typography>
                Disk Size: <b>{disk_size} GB</b>
              </Typography>
            </Grid>

            <Grid size={12}>
              <Typography>
                Max Price: <b>${max_price}</b> per hour
              </Typography>
            </Grid>

            <Grid size={12}>
              <Typography>
                Preemptible: <b>{preemptible ? 'Yes' : 'No'}</b>
              </Typography>
            </Grid>

            {worker_count !== undefined && worker_count > 0 ? (
              <Grid size={12}>
                <Typography>
                  Worker Count: <b>{worker_count}</b>
                </Typography>
              </Grid>
            ) : null}

            {datasets_size !== undefined && datasets_size > 0 ? (
              <Grid size={12}>
                <Typography>
                  Datasets Size: <b>{datasets_size} GB</b>
                </Typography>
              </Grid>
            ) : null}

            {available === false ? (
              <Grid size={12}>
                <Alert severity='warning'>
                  Selected GPU types may not be available in all regions
                </Alert>
              </Grid>
            ) : null}
          </Grid>
        </Paper>
      </Collapse>
    </Box>
  );
}

